var styleDataHash = '25ac848c';  
export const injectCss = (() => {
  var css = `.qA28k{box-sizing:border-box;color:var(--ricos-internal-button-color,var(--ricos-text-on-action-color,var(--ricos-background-color,#fff)));display:block;font-size:var(--ricos-internal-button-font-size,14px);position:relative;text-decoration:none;width:min(100%,var(--ricos-internal-button-custom-width),auto)}[dir] .qA28k{background:var(--ricos-internal-button-background,var(--ricos-action-color,#116dff));border:var(--ricos-internal-button-border-width,0) solid var(--ricos-internal-button-border-color,var(--ricos-text-on-action-color,var(--ricos-background-color,#fff)));border-radius:var(--ricos-internal-button-border-radius);cursor:pointer;padding:var(--ricos-internal-button-padding,12px)}.forced-hover .qA28k,.qA28k:hover{color:var(--ricos-internal-button-color-hover,var(--ricos-text-on-action-color,var(--ricos-background-color,#fff)))}[dir] .forced-hover .qA28k,[dir] .qA28k:hover{background:var(--ricos-internal-button-background-hover,var(--ricos-action-color,#116dff));border:var(--ricos-internal-button-border-width) solid var(--ricos-internal-button-border-color-hover,var(--ricos-text-on-action-color,var(--ricos-background-color,#fff)))}[dir] .E0qbC{margin-bottom:6px;margin-top:6px}.tUlvB{font-family:var(--ricos-custom-p-font-family);line-height:21px;min-width:16px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}[dir] .tUlvB{text-align:center}.vM2qN{width:auto}`;
  var isTest = typeof process !== 'undefined' && process.env && process.env['NODE_ENV'] === 'test';

  if (isTest || !css || typeof document === 'undefined') { return; }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.setAttribute('data-ricos-style-hash', styleDataHash);
  style.type = 'text/css';

  head.appendChild(style);

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});





